module.exports = __webpack_public_path__ + "static/media/PLAYFUL.8a25888b.svg";